<ng-container *ngIf="vm$ | async as vm">
    <!-- <div class="big-background"  [style.background-image]="'url('+imageUrl+')'"> -->
    <div class="big-background big-only">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div style="display:flex;flex-direction:column;height:100%;align-items: center;">
                        <div style="flex:2;display:flex;flex-direction:column;justify-content: space-around;">
                            <div style="text-align: center;flex:1"></div>
                            <h1 style="text-align: center;flex:1">{{contentName}}</h1>
                        </div>
                        <p style="flex:1">{{ date | date}}</p>
                    </div>
                </div>
                <div class="col"><img src={{imageUrl}} alt="banner image"></div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <nb-card style="width:100%">
                <nb-card-body>
                <div class="row">
                    <div class="col-md-9">
                        <div class="row">
                            <div class="col">
                                <ubs-blog-article [date]="date"  [selectedBlogEntry]="vm.selectedBlogEntry"></ubs-blog-article>
                            </div>
                        </div>
                        <div class="row">
                            <div *ngFor="let blogEntry of vm.blogEntries" class="col">
                                <p>
                                    <a routerLink="{{getLinkText(blogEntry)}}">{{blogEntry?.contentName}}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <ubs-blog-menu [blogs]="vm.blogs" [blogEntries]="vm.blogEntries" [multiBlog]="multiBlog"></ubs-blog-menu>
                    </div>
                </div> 
                </nb-card-body>
            </nb-card>
        </div>
    </div>
</ng-container>


